import Container from '@admin/components/container'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

const map = {
  plans: [
    { value: 'pro', text: 't(Pro)' },
    { value: 'essentials', text: 't(Essentials)' }
  ],
  addons: [
    { value: 'logo', text: 't(Logo)' },
    { value: 'brand', text: 't(Brand)' },
    { value: 'singlepage', text: 't(Single Page Website)' },
    { value: 'sevenpage', text: 't(Seven Page Website)' }
  ]
}

class Clone extends React.Component {

  static contextTypes = {
    provider: PropTypes.object,
    modal: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
    plans: PropTypes.array,
    signup_page: PropTypes.object
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { plans, signup_page } = this.props
    const { provider } = this.context
    const { config } = signup_page
    return {
      title: 't(Duplicate Signup Page)',
      action: `/api/admin/truevail/admin/signup_pages/${signup_page.id}/clone`,
      method: 'POST',
      saveText: 't(Clone)',
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            {
              label: 't(Title)',
              name: 'title',
              type: 'textfield',
              placeholder: 't(Enter the title)',
              required: true,
              defaultValue: `Copy of ${signup_page.title}`
            },
            {
              label: 't(URL)',
              name: 'permalink',
              type: 'permalinkfield',
              prefix: '/signup',
              required: true,
              host: provider.admin_host,
              placeholder: '/path/to/signup'
            }
          ]
        },
        {
          label: 't(Details)',
          fields: [
            ...map.plans.map(plan => ({
              label: plan.text,
              type: 'segment',
              fields: [
                {
                  type: 'fields',
                  fields: [
                    {
                      label: 't(Monthly Plan)',
                      name: `config.${plan.value}.monthly_plan_id`,
                      type: 'dropdown',
                      options: plans.filter(plan => {
                        return plan.title.search('month') >= 0
                      }).map(plan => ({
                        value: plan.id,
                        text: `${plan.title} (${plan.price} / ${plan.frequency.units})`
                      })),
                      required: true,
                      defaultValue: config?.[plan.value]?.monthly_plan_id
                    },
                    {
                      label: 't(Yearly Plan)',
                      name: `config.${plan.value}.yearly_plan_id`,
                      type: 'dropdown',
                      options: plans.filter(plan => {
                        return plan.title.search('year') >= 0
                      }).map(plan => ({
                        value: plan.id,
                        text: `${plan.title} (${plan.price} / ${plan.frequency.units})`
                      })),
                      required: true,
                      defaultValue: config?.[plan.value]?.yearly_plan_id
                    }
                  ]
                }
              ]
            })),
            ...map.addons.map(addon => ({
              label: addon.text,
              type: 'segment',
              fields: [
                {
                  type: 'fields',
                  fields: [
                    {
                      label: 't(Price)',
                      name: `config.${addon.value}.price`,
                      type: 'moneyfield',
                      required: true,
                      defaultValue: config?.[addon.value]?.price
                    },
                    {
                      label: 't(Discounted Price)',
                      name: `config.${addon.value}.discount_price`,
                      type: 'moneyfield',
                      defaultValue: config?.[addon.value]?.discount_price
                    }
                  ]
                }
              ]
            })),
            {
              label: 't(Setup Fee)',
              name: 'config.setup_fee',
              type: 'moneyfield',
              required: true,
              defaultValue: config?.setup_fee ?? 0.00
            },
            {
              label: 't(Free Setup)',
              name: 'config.free_setup',
              type: 'checkbox',
              defaultValue: config?.free_setup ?? true
            },
            {
              label: 't(Trial Length)',
              name: 'config.trial_length',
              type: 'numberfield',
              required: true,
              defaultValue: config?.trial_length ?? 1
            }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(signup_page) {
    this.context.router.push(`/admin/truevail/admin/signup_pages/${signup_page.id}`)
    this.context.modal.close()
  }

}

const mapResources = (props, context) => ({
  plans: '/api/admin/subscriptions/services/3/plans'
})

export default Container(mapResources)(Clone)
